import { INST_URL, MAIN_URL, MAIN_URL_SANY, OWN_DELIVERY_TYPE } from "../utils/constants";

class InstApi {
  // constructor({ baseUrl }) {
  //   MAIN_URL = baseUrl;
  // }

  _checkResponse(res) {
    if (res.ok) {
      return res.json();
    } else {
      const statusCode = res.status;
      return res.json().then((res) => {
        return Promise.reject({
          statusCode: statusCode,
          message: res.msg,
          detail: res.detail,
        });
      });
    }
  }

  
  getPosts({ limit }) {
    let params = {};
    if (limit) params.limit = limit;

    return fetch(
      `${INST_URL}/instagram/get_posts?` +
      new URLSearchParams({ data: JSON.stringify(params) }),
      {
        method: "GET",
        // credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    ).then(this._checkResponse);
  }

}



const instApi = new InstApi({
  baseUrl: INST_URL,
});

export default instApi;
